import * as React from "react";
import { toast } from "react-toastify";
import { defaultToastOptions, groupContext } from "../index.js";
import { providePriceForExtraOffer } from "../../../../../../sharedScripts/priceProviderInterpreter.js";
import executeRequest from "../../../../../modules/request.js";
import Button from "../../../../../shared/ui/inputs/classicButton.js";
import { useGlobalUpdate, } from "../../scripts/useGlobalUpdate.js";
import "./disposableOfferOrder.css";
export const updateOneTimeOfferEmitter = {
    name: "offer-update",
    state: 0,
    listeners: [],
};
export function DisposableOfferOrder(props) {
    var _a, _b;
    const { emit, state } = useGlobalUpdate(updateOneTimeOfferEmitter);
    const group = React.useContext(groupContext);
    const { item } = props;
    const currentOffer = group.categories[props.item.categoryIndex].offers[props.item.offerIndex];
    const { canSelectMultiple, name } = currentOffer;
    async function removeItem() {
        const { status } = await executeRequest(`/api/public/users/gallery/oneTimeOffer/${props.item.categoryIndex}/${props.item.offerIndex}`, "DELETE", {});
        if (status === 403) {
            return toast.error("Zamówienie oczekuje na płatność i nie może już być edytowane. Możesz utworzyć nowe zamówienie lub opłacić aktualne.", defaultToastOptions);
        }
        if (status !== 200) {
            return toast.error("Nie udało się usunąć zamówienia", defaultToastOptions);
        }
        props.onUpdate();
        emit(state + 1);
        return toast.success("Usunięto pomyślnie", defaultToastOptions);
    }
    async function updateItem(count) {
        if (count <= 0) {
            return toast.error("Ilośc sztuk nie może być równa zero", defaultToastOptions);
        }
        const { status } = await executeRequest("/api/public/users/gallery/oneTimeOffer", "PATCH", {
            offerName: props.item.name,
            categoryIndex: props.item.categoryIndex,
            added: true,
            textInput: props.item.textInput,
            count: count,
        });
        if (status != 200) {
            return toast.error("Nie udało się zmienić ilości", defaultToastOptions);
        }
        props.onUpdate();
        return toast.success("Zmieniono pomyślnie", defaultToastOptions);
    }
    return (React.createElement("li", { className: "image-order-list-part disposable-offer-list-part" },
        React.createElement("div", null, (_a = props.item.label) !== null && _a !== void 0 ? _a : props.item.name),
        React.createElement("div", null,
            canSelectMultiple && (React.createElement("div", { className: "image-format-container" },
                "Sztuk ", (_b = props.item.count) !== null && _b !== void 0 ? _b : 1,
                React.createElement(Button, { value: "dec", text: "-", classNames: "change-count-button", onClick: () => updateItem(item.count - 1) }),
                React.createElement(Button, { value: "inc", text: "+", classNames: "change-count-button", onClick: () => updateItem(item.count + 1) }))),
            props.item.textInput && (React.createElement(React.Fragment, null,
                "Dodatkowe informacje: ",
                props.item.textInput)),
            "Kwota:",
            " ",
            providePriceForExtraOffer({
                categoryIndex: item.categoryIndex,
                categoryName: item.categoryName,
                offerIndex: item.offerIndex,
                offerName: name,
                price: item.price,
                userId: "",
                count: item.count,
                textInputContent: item.textInput,
            }),
            " ",
            "z\u0142"),
        React.createElement(Button, { value: "remove_disposable_item", text: "", version: "alternative", onClick: removeItem },
            React.createElement("img", { src: "../../assets/icons/delete.svg", width: "24" }))));
}
